'use strict';

angular.module('shiftTraderApp')
    .directive('saPositionDepartmentEditor', function () {
      return {
        templateUrl: 'views/directives/saPositionDepartmentEditor.html',
        restrict: 'A',
        scope: {
          me:'=loggedInUser',
          org:'=',
          allPositions: '=positions',
          saveStateCallback: '&saveStatusUpdate'
        },
        link: function(scope) {
          scope.$on('$destroy', function() {
            $(document).unbind('keydown');
          });
        },
        controller: ['$scope', '$q', '$confirm', 'Positions', 'Departments', '$timeout', 'SAErrorHandler', 'toastr', function($scope, $q, $confirm, Positions, Departments, $timeout, SAErrorHandler, toastr) {
          $scope.posSortableOptions = {
            placeholder: 'pos_placeholder',
            connectWith: '.pos_wrapper',
            revert: 100,
            scrollSpeed: 10,
            scrollSensitivity: 25,
            opacity: 0.6,
            handle: '.pos_handle',
            zIndex: 2000,
            update: function(event, ui) {
              if (_.isNull(ui.sender)) {
                ui.item.scope().pos.department_id = parseInt(ui.item.sortable.droptarget.attr('data-dept-id'));
              }
            }
          };

          var keydownFunction = function(event, enterFunc, escFunc) {
            if (event.which === 27) { // ESC
              $scope.$apply(escFunc);
            } else if (event.which === 13) { // ENTER
              $scope.$apply(enterFunc);
            }
          };

          $scope.deptSortableOptions = {
            revert: 300,
            tolerance: 'pointer',
            handle: '.dept_handle',
            placeholder: 'dept_placeholder'
          };

          if (_.findIndex($scope.org.departments, {id: null}) < 0) {
            $scope.org.departments.push({
              id: null,
              name: 'Uncategorized',
              positions: []
            });
          }

          var updateDepartments = function(skipSelectedListSet) {
            var deptCollapsedStates = {};
            _.each($scope.departments, function(dept) {
              deptCollapsedStates[dept.id] = !!dept._collapsed;
            });

            //console.log(deptCollapsedStates);

            $scope.departments = _.map($scope.org.departments, function(dept) {
              dept.positions = _.where($scope.allPositions, {department_id: dept.id});
              dept._collapsed = !!deptCollapsedStates[dept.id];
              return dept;
            });

            if (!$scope.state.sortable && !skipSelectedListSet) {
              $scope.selectedList = $scope.departments;
              $scope.sortableDepartments = _.cloneDeep($scope.departments);
            }
          };

          $scope.state = {
            currentEditingPos: -1,
            currentEditingDept: -1,
            sortable: false,
            deleteDeptWarningId: -1,
            q: {},
            isInSandboxMode: $scope.org.$isInSandboxMode(),
            showExternalId: !!$scope.org.organization_config.external_id_integration_enabled,
            editingAdv: false
          };

          if ($scope.org.demo_metadata._filled_at_mmnt) {
            $scope.state.sandboxFilledAtMoment = moment($scope.org.demo_metadata._filled_at_mmnt);

          }

          $scope.state.q.wasPositionCreatedInSandbox = function(pos) {
            return moment(pos.created_at).isBefore($scope.state.sandboxFilledAtMoment);
          };

          $scope.state.q.isCurrentEditingPos = function(pos) {
            return pos.id === $scope.state.currentEditingPos;
          };

          $scope.state.q.isCurrentEditingAdvPos = function(pos) {
            return $scope.state.editingAdv;
          };

          $scope.state.q.isCurrentEditingDept = function(dept) {
            return dept.id === $scope.state.currentEditingDept;
          };

          $scope.state.q.isNewPos = function(pos) {
            return pos.id === null;
          };

          $scope.state.q.isNewDept = function(dept) {
            return dept.id === -2;
          };

          $scope.state.q.isNotDept = function(dept) {
            return dept.id === null;
          };

          $scope.state.q.deptEditActive = function() {
            return $scope.state.currentEditingDept !== -1;
          };

          $scope.state.q.posEditActive = function() {
            return $scope.state.currentEditingPos !== -1;
          };

          $scope.state.q.deptDeleteWarningActive = function () {
            return $scope.state.deleteDeptWarningId !== -1;
          };

          $scope.state.q.isDeleteWarningDept = function(dept) {
            return $scope.state.deleteDeptWarningId === dept.id;
          };

          $scope.editDefaultWages = function() {
            console.log('Editing Default Wages');
            $(document).unbind('keydown');

            var rebind = function() {
              // Rebind the keys
              var escFunc = function() {
                $scope.cancelEditPosition($scope.editingPos);
              };

              var enterFunc = function() {
                $scope.saveEditPosition($scope.editingPos);
              };

              $(document).keydown(function (event) {
                keydownFunction(event, enterFunc, escFunc);
              });
            };

            $confirm({
              text: 'Setting default wages on a position will automatically generate a pay rate exception when new employees are added to this position. A typical use of this setting is when you have a position that is paid tips and has a lower standard wage. Are you sure you want to edit this setting?',
              ok: 'Proceed',
              cancel: 'No, I\'ll go back.'
            }).then(function() {
              $scope.state.editingAdv = true;

              // Rebind the keys
              rebind();
            }, function() {
              rebind();
            });
          };

          updateDepartments();

          $scope.enterSortable = function() {
            $scope.sortableDepartments = _.cloneDeep($scope.departments);
            $scope.selectedList = $scope.sortableDepartments;
            $scope.state.sortable = true;
          };

          $scope.cancelSortable = function() {
            $scope.selectedList = $scope.departments;
            $scope.state.sortable = false;
          };

          $scope.saveSortable = function() {
            $scope.departments = _.cloneDeep($scope.sortableDepartments);
            _($scope.departments).forEach(function(dept, idy) {
              dept.row_order_position = idy;
              _(dept.positions).forEach(function(pos, idx) {
                pos.row_order_position = idx;
              });
            });

            var promiseArray = [];

            var hasActivePositions = function() {
              return _.where($scope.allPositions, {active: true}).length > 0;
            };

            // Call update function
            if (hasActivePositions()) {
              promiseArray.push(Positions.bulkUpdate($scope.org.id, _.flatten(_.map($scope.departments, function(dept) {
                return _.map(dept.positions, function(pos) {
                  return _.pick(pos, ['id', 'row_order_position', 'department_id']);
                });
              }))));
            }

            promiseArray.concat(_($scope.departments).where(function(dept) {
              return !_.isNull(dept.id);
            }).map(function(dept) {
              return dept.$update({
                row_order_position: dept.row_order_position
              });
            }));

            $q.all(promiseArray)
              .then(function(results) {
                $scope.org.departments = _.cloneDeep($scope.sortableDepartments);

                if ( hasActivePositions() && $scope.allPositions.length === results[0].length) {
                  // this SHOULD always be the branch that runs. Don't know how the else could occur...
                  _.each(results[0], function(pos, idx) {
                    $scope.allPositions[idx] = pos;
                  });
                } else {
                  // this doesn't guarantee the new order of the positions, but it does not give you a crash :-)
                  _.each(results[0], function(pos) {
                    var idy = _.findIndex($scope.allPositions, {id: pos.id});

                    if (idy > -1) {
                      $scope.allPositions[idy] = pos;
                    }
                  });
                }
                //$scope.allPositions = results[0]; // results[0] is the result of the Positions.bulkUpdate (all of the positions we ordered)
                updateDepartments(true);
                $scope.selectedList = $scope.departments;
                $scope.state.sortable = false;
              }, function() {

                console.log('whoops');
              });

          };

          $scope.addDepartment = function () {
            var newDept = {
              id: -2,
              name: '',
              active: true,
              row_order_position: 0,
              _collapsed: false
            };
            $scope.departments.splice(0,0,Departments.initWithData(newDept));
            $scope.editDepartment($scope.departments[0]);
          };

          $scope.editDepartment = function (dept) {
            console.log('Edit department: ' + dept.id);
            $scope.editingDept = _.cloneDeep(dept);
            console.log($scope.editingDept.name);
            $scope.state.currentEditingDept = dept.id;

            $timeout(
              function() {
                $('#dept-' + dept.id + '-focus')[0].select();
              }, 0);

            var escFunc = function() {
              $scope.cancelEditDepartment(dept);
            };

            var enterFunc = function() {
              $scope.saveEditDepartment(dept);
            };

            $(document).keydown(function (event) {
              keydownFunction(event, enterFunc, escFunc);
            });
          };

          $scope.cancelEditDepartment = function (dept) {
            $(document).unbind('keydown');
            if (dept.id === -2) {
              _.remove($scope.departments, {id: -2});
            }
            $scope.state.currentEditingDept = -1;
          };

          $scope.saveEditDepartment = function (dept) {
            if (dept.id !== -2) {
              dept.$update({
                name: $scope.editingDept.name
              })
                .then(function (data) {
                  $scope.state.currentEditingDept = -1;
                }, function (response) {
                  SAErrorHandler.processError(response, 'Could not change name of department.');
                });
            } else {
              // CREATE
              var data = {
                organization_id: $scope.org.id,
                name: $scope.editingDept.name,
                row_order_position: 0
              };

              Departments.create(data)
                .then(function(responseData) {
                  responseData.positions = [];
                  _.extend(dept, responseData);
                  $scope.org.departments.splice(0, 0, dept);
                  updateDepartments();
                  toastr.success('Department ' + responseData.name + ' created.', 'Success');
                  $scope.state.currentEditingDept = -1;
                }, function(response) {
                  SAErrorHandler.processError(response, 'Department ' + data.name + ' creation failed. Try again later.');
                });
            }
          };

          var deleteDepartmentWarning = function(dept) {
            $scope.state.deleteDeptWarningId = dept.id;
          };

          var removePositionsFromDepartment = function(dept) {
            var matchingDeptIndex = _.findIndex($scope.departments, {id: dept.id});
            _.each($scope.departments[matchingDeptIndex].positions, function(pos) {
              var matchingPosIndex = _.findIndex($scope.allPositions, {id: pos.id});
              if (matchingPosIndex > -1) {
                $scope.allPositions[matchingPosIndex].department_id = null;
              }
            });
            dept.positions = [];
            $scope.org.departments = _.cloneDeep($scope.departments);
            updateDepartments();
          };

          $scope.cancelDeleteDepartment = function() {
            $scope.state.deleteDeptWarningId = -1;
          };

          $scope.deleteDepartment = function(dept, confirmed) {
            if (dept.positions.length > 0 && !confirmed) {
              deleteDepartmentWarning(dept);
            } else {
              dept.$makeInactive()
                  .then(function() {
                    removePositionsFromDepartment(dept);
                    $scope.state.deleteDeptWarningId = -1;
                    toastr.success('Department "' + dept.name + '" deleted.', 'Success');
                  }, function() {
                    toastr.error('"' + dept.name + '" could not be deleted. Please try again.', 'Error');
                  });
            }
          };

          $scope.undoDeleteDepartment = function(dept) {
            dept.$makeActive()
                .then(function() {
                  toastr.success('Undo delete "' + dept.name + '" successful.', 'Success');
                }, function() {
                  toastr.error('Could not undo. Please try again.', 'Error');
                });
          };

          $scope.addPosition = function(dept) {
            if ($scope.state.currentEditingPos < 0) {
              dept._collapsed = false;

              var default_training_hourly_wage = (!_.isNull($scope.org.organization_config.default_training_hourly_wage) &&
                    !_.isUndefined($scope.org.organization_config.default_training_hourly_wage)) ?
                      $scope.org.organization_config.default_training_hourly_wage :
                      0.0;

              var newPos = {
                id: null,
                name: '',
                department_id: dept.id,
                organization_id: dept.organization_id
              };

              if ($scope.state.showExternalId) {
                newPos.external_id = '';
              }

              dept.positions.push(Positions.initWithData(newPos));
              $scope.editPosition(_.last(dept.positions));
            }
          };

          $scope.editPosition = function(pos) {
            if ($scope.state.isInSandboxMode && !!$scope.state.sandboxFilledAtMoment && $scope.state.q.wasPositionCreatedInSandbox(pos)) {
              toastr.error('You need to empty the sandbox before you can edit positions.', 'Error');
            } else {
              $scope.state.currentEditingPos = pos.id;
              $scope.editingPos = _.cloneDeep(pos);

              $timeout(
                  function() {
                    $('#pos-' + (!_.isNull(pos.id) ? pos.id : '') + '-focus')[0].select();
                  }, 0);

              var escFunc = function() {
                $scope.cancelEditPosition(pos);
              };

              var enterFunc = function() {
                $scope.saveEditPosition(pos);
              };

              $(document).keydown(function (event) {
                keydownFunction(event, enterFunc, escFunc);
              });

            }

          };

          $scope.cancelEditPosition = function (pos) {
            $(document).unbind('keydown');
            $scope.state.editingAdv = false;
            $scope.state.currentEditingPos = -1;
            var dept = _.find($scope.departments, {id: pos.department_id});
            _.remove(dept.positions, function(p) {
              return _.isNull(p.id);
            });
          };

          $scope.saveEditPosition = function (pos) {
            $scope.state.editingAdv = false;
            if (_.isUndefined($scope.editingPos.name) || $scope.editingPos.name.trim() === '') {
              toastr.error('Please give your new position a name.', 'Error');
              return false;
            } else if (_.contains(_.pluck(_.where($scope.allPositions, function(p) { return p.id !== $scope.editingPos.id;}), 'name'), $scope.editingPos.name.trim())) {
              toastr.error('Position name already exists. Please try a different one.', 'Error');
              return false;
            }
//            if we only allow the same position name in different positions
//            else if (_.contains(_.pluck(
//                _.where($scope.allPositions, {department_id: $scope.editingPos.department_id}),
//                'name'), $scope.editingPos.name.trim())) {
//              flash.error = 'Position name already exists. Please try a different one.'
//              return false;
//            }

            $(document).unbind('keydown');

            if (!_.isNull(pos.id)) {
              var updateData = {
                default_hourly_wage: $scope.editingPos.default_hourly_wage,
                name: $scope.editingPos.name.trim(),
                default_training_hourly_wage: $scope.editingPos.default_training_hourly_wage
              };

              if ($scope.state.showExternalId) {
                updateData.external_id = $scope.editingPos.external_id.trim();
              }

              $scope.editingPos.$update(updateData)
                  .then(function (posData) {
                    $scope.editingPos.department = _.find($scope.org.departments, {id: $scope.editingPos.department_id});
                    $scope.allPositions[_.findIndex($scope.allPositions, {id: $scope.editingPos})] = Positions.initWithData($scope.editingPos);
                    _.extend(pos, posData);
                    updateDepartments();

                    toastr.success('Position ' + $scope.editingPos.name + ' updated.', 'Success');
                    $scope.state.currentEditingPos = -1;
                  }, function () {
                    toastr.error('Position ' + pos.name + ' update failed. Try again later.', 'Error');
                  });
            } else {
              // CREATE
              var data = {
                organization_id: $scope.org.id,
                default_hourly_wage: $scope.editingPos.default_hourly_wage,
                name: $scope.editingPos.name.trim(),
                default_training_hourly_wage: $scope.editingPos.default_training_hourly_wage,
                department_id: pos.department_id
              };

              if ($scope.state.showExternalId) {
                data.external_id = $scope.editingPos.external_id.trim();
              }

              Positions.create(data)
                  .then(function(responseData) {
                    responseData.department = _.find($scope.org.departments, {id: responseData.department_id});
                    $scope.allPositions.push(responseData);
                    _.extend(pos, responseData);
                    updateDepartments();
                    toastr.success('Position ' + responseData.name + ' created.', 'Success');
                    $scope.state.currentEditingPos = -1;
                  }, function() {
                    toastr.error('Position ' + data.name + ' creation failed. Try again later.', 'Error');
                  });
            }
          };

          $scope.deletePosition = function(pos) {
            pos.$makeInactive()
                .then(function() {
                  pos.active = false;
                  toastr.success('Position "' + pos.name + '" deleted.', 'Success');
                }, function() {
                  toastr.error('"' + pos.name + '" could not be deleted. Please try again.', 'Error');
                });
          };

          $scope.undoDeletePosition = function(pos) {
            pos.$makeActive()
                .then(function() {
                  pos.active = true;
                  toastr.success('Undo delete "' + pos.name + '" successful.', 'Success');
                }, function() {
                  toastr.error('Could not undo. Please try again.', 'Error');
                });
          };

          $scope.toggleDepartmentCollapsed = function(dept) {
            setDeptCollapsedState(!dept._collapsed, dept.id);
          };

          var setDeptCollapsedState = function(state, dept_id) {
            // loop at both lists, use _.find to match on dept_id, set collapse state
            var idx = _.findIndex($scope.departments, {id: dept_id});
            if (idx > -1) {
              $scope.departments[idx]._collapsed = state;
            }
            var idy = _.findIndex($scope.sortableDepartments, {id: dept_id});
            if (idy > -1) {
              $scope.sortableDepartments[idy]._collapsed = state;
            }
          };

          var setAllDeptCollapsedState = function(state) {
            _.each($scope.selectedList, function(dept) {
              setDeptCollapsedState(state, dept.id);
            });
          };

          $scope.expandAllDepts = _.wrap(false, setAllDeptCollapsedState);
          $scope.collapseAllDepts = _.wrap(true, setAllDeptCollapsedState);

          $scope.$watch('state.sortable', function() {
            if (!_.isUndefined($scope.saveStateCallback())) {
              $scope.saveStateCallback()(!$scope.state.sortable);
            }
          });

          var activeDepts = lodash.filter($scope.selectedList, {active: true});
          if (activeDepts.length > 0 && $scope.allPositions.length === 0) {
            $timeout(function() {
              var idx = lodash.findIndex($scope.selectedList, { id: activeDepts[0].id });
              $scope.addPosition($scope.selectedList[idx]);
            }, 250)
          }

        }]
      };
    });
